import React, { useEffect, useState } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { 
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  TextField,
  makeStyles
} from '@material-ui/core';
  
const useStyles = makeStyles(() => ({
  root: {}
}));

const ProfileDetails = (props,{className, ...rest }) => {
  const classes = useStyles();
  console.log("props.userDetails",props.userDetails);
  const [values, setValues] = useState({
    FirstName:"",
    LastName:"",
    Email:"",
    PhoneNumber:"",
    Pan:"",
    Tan:"",
    CompanyName:""
  });
  console.log("values",values);
  const handleChange = (event) => {
    setValues({
      ...values,
      [event.target.name]: event.target.value
    });
  };
  
  useEffect(() => {
    setValues(props.userDetails);
  }, [props]); 
  return (
    <form
      autoComplete="off"
      noValidate
      className={clsx(classes.root, className)}
      {...rest}
    >
      <Card>
        <CardHeader
          subheader="The information can be edited"
          title="Profile"
        />
        <Divider />
        <CardContent>
          <Grid
            container
            spacing={3}
          >
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                //helperText="Please specify the first name"
                label="First name"
                name="firstName"
                onChange={handleChange}
                required
                value={values.FirstName?values.FirstName:""}
                variant="outlined"
                defaultValue="First name" 
                disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Last name"
                name="lastName"
                onChange={handleChange}
                required
                value={values.LastName?values.LastName:""}
                variant="outlined"
                defaultValue="Disabled" disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Email Address"
                name="email"
                onChange={handleChange}
                required
                value={values.Email?values.Email:""}
                variant="outlined"
                defaultValue="Disabled" disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="Phone Number"
                name="phone"
                onChange={handleChange}
                type="number"
                value={values.PhoneNumber?values.PhoneNumber:""}
                variant="outlined"
                defaultValue="Disabled" disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="PAN"
                name="pan"
                onChange={handleChange}
                required
                value={values.Pan?values.Pan:""}
                variant="outlined"
                defaultValue="Disabled" disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
              <TextField
                fullWidth
                label="TAN"
                name="tan"
                onChange={handleChange}
                required
                value={values.Tan?values.Tan:""}
                variant="outlined"
                defaultValue="Disabled" disabled
              />
            </Grid>
            <Grid
              item
              md={6}
              xs={12}
            >
               <TextField
                fullWidth
                label="Company Name"
                name="company"
                onChange={handleChange}
                required
                value={values.CompanyName?values.CompanyName:""}
                variant="outlined"
                defaultValue="Disabled" disabled
              />            
               
            </Grid>
          </Grid>
        </CardContent>
        <Divider /> 
      </Card>
    </form>
  );
};

ProfileDetails.propTypes = {
  className: PropTypes.string
};

export default ProfileDetails;
